var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pop',{ref:"pop",attrs:{"clickClose":false,"bg":"'rgba(0,0,0,.1)'"}},[_c('div',{attrs:{"slot":"popContent"},slot:"popContent"},[_c('span',{staticClass:"alertContent",style:(_vm.alertStyle)},[_vm._v(" "+_vm._s(_vm.alertContent)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }